(function () {
  'use strict';

  angular.module('wsLrs.directives').
  /*
  * data is the full set of data that we are paging,
  *   there is a watch that will recreate the pager if this changes
  * displayCallback is a function that takes an array of page data as an argument
  *   this function is called when we change pages
  * */

  directive('wsPager', ['$rootScope', '$q', 'wsEventNames', '$timeout', function ($rootScope, $q, wsEventNames, $timeout) {
    return {
      templateUrl: "modules/common/directives/pager/pager.html",
      scope: {
        data: "=?",
        pageData: "=?",
        pageSize: "=?",
        hidePageSize: "=?",
        hideFirstPageLink: "=?",
        hideLastPageLink: "=?",
        displayCallback: "=?",
        fetchPage: "=?",
        setPage: "=?",
        setPageEvent: "=?",
        onLoad: '<' // Callback to call when pager is loaded. Useful to avoid timing issues
      },
      link: function link($scope) {
        $scope.mathMin = Math.min.bind(Math);
        $scope.displayCallback = $scope.displayCallback || function () {};
        var onLoadHasBeenCalled = false;

        // paging support
        $scope.pagingEnabled = true;
        $scope.pages = null;
        $scope.resultsCount = 0;
        $scope.minPage = 1;
        $scope.maxPage = 1;
        $scope.pageNumber = 1;
        $scope.pageSize = $scope.pageSize || 50;
        $scope.pageSizes = [5, 10, 25, 50, 100]; // empty array will disable alt page sizes

        $scope.showPager = function showPager() {
          if (!$scope.pagingEnabled) {
            return false;
          }
          if ($scope.resultsCount <= $scope.pageSizes[0]) {
            return false;
          }
          return $scope.pages && $scope.pages.length > 1 || $scope.pageSizes.length && $scope.pageSizes[0] < $scope.pageSize;
        };
        $scope.$watchCollection('data', function () {
          if ($scope.data) {
            $scope.resultsCount = $scope.data.length;
            $scope.resetPager();
          }
        });
        var updatePages = function updatePages() {
          // set bounds on pages
          var lowerBound = Math.max($scope.pageNumber - 2, $scope.minPage);
          var upperBound = Math.min($scope.pageNumber + 2, $scope.maxPage);
          if (upperBound === $scope.maxPage) {
            lowerBound = Math.max(upperBound - 4, $scope.minPage);
          }
          if (lowerBound === $scope.minPage) {
            upperBound = Math.min(lowerBound + 4, $scope.maxPage);
          }

          // reset pages array
          var pages = [];
          for (var i = lowerBound; i <= upperBound; i++) {
            pages.push(i);
          }
          $scope.pages = pages;
        };
        $scope.fetchPage = $scope.fetchPage || function (offset, limit) {
          $scope.pageData = $scope.pagingData.slice(offset, offset + limit);
          if ($scope.displayCallback) {
            $scope.displayCallback($scope.pageData);
          }
          var future = $q.defer();
          future.resolve({
            count: $scope.pagingData.length,
            results: $scope.pageData
          });
          return future.promise;
        };

        // set to pageNumber (or closest valid page)
        // Allow empty parameter to be called to "refresh" the current page
        $scope.setPage = function setPage() {
          var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'current';
          $scope.savedPageNumber = $scope.pageNumber;
          if (pageNumber > $scope.maxPage) {
            $scope.pageNumber = $scope.maxPage;
          } else if (pageNumber < $scope.minPage) {
            $scope.pageNumber = $scope.minPage;
          } else if (pageNumber !== 'current') {
            $scope.pageNumber = pageNumber;
          }
          var start = ($scope.pageNumber > 0 ? $scope.pageNumber - 1 : 0) * $scope.pageSize;

          // After we've set our starting offset, make sure to change this to a sensible
          // number. If it's been set to 0, it should actually be 1.
          if ($scope.pageNumber === 0) {
            $scope.pageNumber = 1;
          }
          $scope.fetchPage(start, $scope.pageSize).then(function (results) {
            if (results.hasError) {
              $scope.pageNumber = $scope.savedPageNumber;
              return;
            }
            $scope.resultsCount = results ? results.count : 0;
            if (!results || results.count === undefined) {
              return;
            }
            $scope.pageData = results.results;
            $scope.minPage = 1;
            $scope.maxPage = $scope.resultsCount === 0 ? 1 : Math.ceil($scope.resultsCount / $scope.pageSize);
            // validate pageNumber after fetch
            $scope.pageNumber = $scope.pageNumber > $scope.maxPage ? $scope.maxPage : $scope.pageNumber < $scope.minPage ? $scope.minPage : $scope.pageNumber;
            // check if pageData is empty to signal whether we should try to move back a page
            if ($scope.pageNumber > 1 && Array.isArray($scope.pageData) && $scope.pageData.length === 0) {
              $scope.setPage(Math.max($scope.pageNumber - 1, $scope.maxPage));
            }
            updatePages();
          });
        };
        $scope.setPageSize = function setPageSize(size) {
          var prevSize = $scope.pageSize;
          $scope.pageSize = size;
          var newPage = 1;
          if ($scope.pageSize > prevSize) {
            newPage = Math.ceil($scope.pageNumber * prevSize / $scope.pageSize);
          } else {
            newPage = Math.round(($scope.pageNumber - 1) * prevSize / $scope.pageSize + 1);
          }
          $scope.maxPage = Math.ceil($scope.resultsCount / $scope.pageSize);
          $scope.resetPager(newPage);
        };
        $scope.$on($scope.setPageEvent || wsEventNames.pager.setPage, function (evt, pageNumber) {
          if (pageNumber === "last") {
            $scope.setPage($scope.maxPage);
          } else {
            $scope.setPage(pageNumber);
          }
        });
        $scope.resetPager = function resetPager(p) {
          $scope.pagingData = $scope.data;
          if ($scope.resultsCount <= 0) {
            $scope.pageData = $scope.pagingData;
            if (!onLoadHasBeenCalled && $scope.onLoad && typeof $scope.onLoad === 'function') {
              // Wrap this in a $timeout, which will push its execution into the next
              // digest cycle. This allows $scope.setPage time to bind to the parent
              // scope and makes itself available to be called from the parent controller.
              // See search.js for an example where we initialize by calling $scope.setPage();
              $timeout(function () {
                $scope.onLoad();
                onLoadHasBeenCalled = true;
              });
            }
            return;
          }

          // reset extents and pages
          $scope.setPage(p || 1);
        };
        $scope.resetPager();
      }
    };
  }]);
})();
